module.exports = __webpack_public_path__ + "static/vo-c1bbd112459e2308d3950faa6672bb7e.mp3";